/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionMessageContentMode } from './EmployeeExecutionMessageContentMode';
/**
 * Customer-facing message delivery operation.
 */
export type EmployeeExecutionMessageSendOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionMessageSendOperation.kind;
    /**
     * Whether content is literal or describes a communication intent.
     */
    contentMode: EmployeeExecutionMessageContentMode;
    /**
     * Exact message or communication intent, according to contentMode.
     */
    content: string;
};
export namespace EmployeeExecutionMessageSendOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        MESSAGE_SEND = 'message-send',
    }
}

